module.exports = __webpack_public_path__ + "static/media/prizes_fr.bc50daf6.png";